<div class="payroll-detail-page">
  <div class="page-header">
    <div>
      <button class="btn-back" (click)="back()">← Périodes</button>
      <h1>Relevés d'activité</h1>
      <p class="subtitle">
        {{ timesheets.length }} relevé(s) — {{ totalHours }} h au total
      </p>
    </div>
    <div class="header-actions">
      <button class="btn btn-primary" (click)="sendToSage()" [disabled]="sending || pendingCount === 0">
        {{ sending ? 'Envoi...' : 'Envoyer à Sage (' + pendingCount + ')' }}
      </button>
      <button class="btn-refresh" (click)="load()" [disabled]="loading">Rafraîchir</button>
    </div>
  </div>

  @if (loading) {
    <div class="empty-state">Chargement...</div>
  } @else if (timesheets.length === 0) {
    <div class="empty-state">
      Aucun relevé pour cette période. Vérifiez que des missions signées existent sur ce mois,
      puis relancez « Préparer la période ».
    </div>
  } @else {
    <div class="sheets-table">
      <div class="table-row table-head">
        <div>Professionnel</div>
        <div>Mission</div>
        <div>Établissement</div>
        <div>Jours</div>
        <div>Heures</div>
        <div>Taux</div>
        <div>Statut</div>
      </div>
      @for (s of timesheets; track s.id) {
        <div class="table-row table-data" (click)="toggle(s)" [class.expanded]="expandedId === s.id">
          <div class="candidat">{{ s.candidatFullname || ('Candidat #' + s.candidatId) }}</div>
          <div>{{ s.missionRef || s.missionId }}</div>
          <div>{{ s.establishmentName }} <span class="site" *ngIf="s.siteName">/ {{ s.siteName }}</span></div>
          <div>{{ s.totalDays }}</div>
          <div>{{ s.totalHours }} h</div>
          <div>
            @if (s.baseHourlyRate) {
              {{ s.baseHourlyRate | number:'1.2-2' }} €/h
            } @else if (s.compensation) {
              {{ s.compensation | number:'1.2-2' }} €/j
            } @else { — }
          </div>
          <div>
            <span class="status-pill"
              [class.ready]="s.status === 'READY'"
              [class.sent]="s.status === 'SENT'"
              [class.error]="s.status === 'ERROR'">
              {{ statusLabel(s.status) }}
            </span>
            @if (s.errorMessage) {
              <div class="error-msg">{{ s.errorMessage }}</div>
            }
          </div>
        </div>
        @if (expandedId === s.id) {
          <div class="day-grid">
            <div class="day-grid-head">
              <div>Date</div><div>Début</div><div>Fin</div><div>Pause</div><div>Heures</div>
            </div>
            @for (d of days(s); track d.date) {
              <div class="day-grid-row">
                <div>{{ d.date | date:'EEE dd/MM' }}</div>
                <div>{{ d.startTime || '—' }}</div>
                <div>{{ d.endTime || '—' }}</div>
                <div>{{ d.pauseMinutes ? d.pauseMinutes + ' min' : '—' }}</div>
                <div>{{ d.hoursWorked }} h</div>
              </div>
            }
            @if (primes(s).length > 0) {
              <div class="primes">
                <strong>Primes :</strong>
                @for (p of primes(s); track p.code) {
                  <span class="prime-chip">
                    {{ p.label || p.code }}
                    @if (p.quantity && p.rate) { ({{ p.quantity }} × {{ p.rate }} €) }
                    @else if (p.amount) { ({{ p.amount }} €) }
                  </span>
                }
              </div>
            }
          </div>
        }
      }
    </div>
  }

  <div class="payslips-section">
    <div class="section-header">
      <h2>Bulletins de paie</h2>
      <button class="btn btn-secondary btn-sm" (click)="refreshPayslips()" [disabled]="refreshingPayslips">
        {{ refreshingPayslips ? 'Récupération...' : 'Récupérer depuis Sage' }}
      </button>
    </div>
    @if (payslips.length === 0) {
      <div class="empty-state small">
        Aucun bulletin pour cette période (l'intégration Sage doit être active et la paie validée).
      </div>
    } @else {
      <div class="sheets-table">
        <div class="table-row table-head payslip-cols">
          <div>Bulletin</div>
          <div>Matricule</div>
          <div>Brut</div>
          <div>Net à payer</div>
          <div>Coût total</div>
          <div>Paiement</div>
          <div></div>
        </div>
        @for (b of payslips; track b.id) {
          <div class="table-row table-data payslip-cols">
            <div>{{ b.payslipExternalId }}</div>
            <div>{{ b.sageMatricule }}</div>
            <div>{{ b.grossSalary | number:'1.2-2' }} €</div>
            <div>{{ b.netToPay | number:'1.2-2' }} €</div>
            <div>{{ b.totalEmployerCost | number:'1.2-2' }} €</div>
            <div>{{ b.paymentDate | date:'dd/MM/yy' }}</div>
            <div>
              <button class="btn btn-secondary btn-sm" (click)="downloadPayslip(b)">PDF</button>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
